import React from 'react';
import { Poppins } from 'src/common';
import { BaseCard } from '../../styled';
import styled from 'styled-components';
import { DashboardQuery } from 'src/graphql/_generated';
import { AssessmentState } from '../types';
import { DangerTooltip } from '../comps';

const Wrap = styled(BaseCard)`
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
    height: 100%;

    &__item {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
  }
`;

interface MissingDatameProps {
  value: DashboardQuery['dashboard']['missingData'];
  state: AssessmentState;
}

export const MissingData: React.FC<MissingDatameProps> = ({ state, value }) => {
  return (
    <Wrap>
      <span className="c-title">Missing Scenario Data</span>

      <div className="grid">
        <div className="grid__item">
          <Poppins px={12} weight={500}>
            SCENARIOS
          </Poppins>
          <Poppins px={12} color="cflowerBlue">
            <i>without calculation data</i>
          </Poppins>
          <div style={{ flex: 1 }} />

          {state === 'NO_SCENARIOS' ? (
            <DangerTooltip state={state} />
          ) : (
            <Poppins weight={600} px={26}>
              {value?.scenariosWithoutCalculationData}
            </Poppins>
          )}
        </div>

        <div className="grid__item">
          <Poppins px={12} weight={500}>
            SCENARIOS
          </Poppins>
          <Poppins px={12} color="cflowerBlue">
            <i>without linked controls</i>
          </Poppins>
          <div style={{ flex: 1 }} />

          {state === 'NO_SCENARIOS' ? (
            <DangerTooltip state={state} />
          ) : (
            <Poppins weight={600} px={26}>
              {value?.scenariosWithoutLinkedControls}
            </Poppins>
          )}
        </div>

        <div className="grid__item">
          <Poppins px={12} weight={500}>
            SCENARIOS
          </Poppins>
          <Poppins px={12} color="cflowerBlue">
            <i>without modifiers</i>
          </Poppins>
          <div style={{ flex: 1 }} />

          {state === 'NO_SCENARIOS' ? (
            <DangerTooltip state={state} />
          ) : (
            <Poppins weight={600} px={26}>
              {value?.scenariosWithoutModifiers}
            </Poppins>
          )}
        </div>
      </div>
    </Wrap>
  );
};
